import { ColumnDef, createColumnHelper } from "@tanstack/react-table";
import moment from "moment";
import { type Question } from "../types/qna";
import { translator } from "../utils/translator";
import { getDepartmentName } from "../utils/departmentUtils";
import { Link } from "react-router-dom";

const columnHelper = createColumnHelper<Question>();

export const QnaQuestionTableDef: ColumnDef<Question, any>[] = [
  columnHelper.accessor("id", {
    header: "id",
  }),
  columnHelper.accessor("type", {
    header: "구분",
    cell: (info) => <span>{translator[info.getValue()]}</span>,
  }),
  columnHelper.accessor("title", {
    header: "제목",
  }),
  columnHelper.accessor("user_name", {
    header: "작성자",
  }),
  columnHelper.accessor("created_at", {
    header: "작성일",
    cell: (info) => <span>{moment(info.getValue()).format("YYYY-MM-DD")}</span>,
  }),
  columnHelper.accessor("department", {
    header: "담당부서",
    cell: (info) => <span>{getDepartmentName(info.getValue())}</span>,
  }),
  columnHelper.accessor("status", {
    header: "처리현황",
    cell: (info) => (
      <span className={`status ${info.getValue()}`}>
        {translator[info.getValue()]}
      </span>
    ),
  }),
];

export const QnaStaffTableDef = (
  cancelAnswer: (questionId: number) => Promise<void>
): ColumnDef<Question, any>[] => [
  {
    header: "답변하기",
    cell: (info) =>
      info.row.original.status === "answered" ? (
        <button
          className="warning"
          style={{ display: "table-cell" }}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            if (window.confirm("정말 답변을 취소하시겠습니까?")) {
              cancelAnswer(info.row.original.id);
            }
          }}
        >
          답변취소
        </button>
      ) : (
        <Link
          to={`answer/${info.row.original.id}${window.location.search}`}
          onClick={(e) => e.stopPropagation()}
        >
          <button style={{ display: "table-cell" }}>답변하기</button>
        </Link>
      ),
  },
];
